// Linear stand-ins for `/\{\{\s*(.*?)\s*\}\}/g` and `/\[([^\]]+)\]/g` (Sonar S8786): both were retried from every
// opening delimiter when no closing one followed. A missing closing delimiter now ends the scan, because no
// later opening delimiter can find one either.

/** Replaces each `{{ expression }}` with `replacer(expression)`; the expression is passed trimmed. */
export const replaceTokenExpressions = (text: string, replacer: (expression: string) => string): string => {
  let result = '';
  let index = 0;

  while (index < text.length) {
    const open = text.indexOf('{{', index);
    if (open === -1) break;

    const close = text.indexOf('}}', open + 2);
    if (close === -1) break;

    result += text.slice(index, open) + replacer(text.slice(open + 2, close).trim());
    index = close + 2;
  }

  return result + text.slice(index);
};

/** Replaces each non-empty `[key]` with `replacer(key)`. */
export const replaceBracketKeys = (text: string, replacer: (key: string) => string): string => {
  let result = '';
  let index = 0;

  while (index < text.length) {
    const open = text.indexOf('[', index);
    if (open === -1) break;

    const close = text.indexOf(']', open + 1);
    if (close === -1) break;

    if (close === open + 1) {
      result += text.slice(index, close + 1);
      index = close + 1;
      continue;
    }

    result += text.slice(index, open) + replacer(text.slice(open + 1, close));
    index = close + 1;
  }

  return result + text.slice(index);
};
